import { render } from "./Toolbar.vue?vue&type=template&id=3fe69269"
import script from "./Toolbar.vue?vue&type=script&lang=ts"
export * from "./Toolbar.vue?vue&type=script&lang=ts"
script.render = render

export default script